<script>
  import { ACTIVITY_EVENTS } from '@client/enums';

  /**
   * @typedef {Object} ActivityEntry
   * @property {string} [verb] - The event type (e.g., 'clicked', 'visited').
   * @property {string} [objecttype] - The type of object involved (e.g., 'videoactivity').
   */

  /**
   * A single activity history entry.
   * Should include `verb` and `objecttype` at a minimum.
   * @type {ActivityEntry}
   */
  export let entry = {};

  /**
   * The normalized event type, based on the entry.
   * Falls back to `objecttype` for specific verbs or object types.
   * @type {string | undefined}
   */
  $: event =
    entry.verb === 'clicked' || entry.verb === 'visited' || entry.objecttype === 'videoactivity'
      ? entry.objecttype
      : entry.verb;
</script>

<div class="event" style="background-color: {ACTIVITY_EVENTS[event]?.color}">
  <i class={ACTIVITY_EVENTS[event]?.icon} />
</div>

<style lang="scss" src="./item-event.scss"></style>
